import React, { FC, ReactNode } from 'react';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import SmallButton from 'evcharging/components/SmallButton';
import clsx from 'clsx';
import LightButton from 'evcharging/components/LightButton';
import Desktop from 'evcharging/components/Desktop';

interface FormCardProps {
  image: string;
  title: string;
  text: ReactNode;
  onToggle?: () => void;
  expand: boolean;
}

const ForCard: FC<FormCardProps> = (props) => {
  const { image, title, text, onToggle, expand } = props;
  const theme = useTheme();
  const styles = createStyles(theme, image);

  return (
    <div className={styles.root}>
      <div className={styles.image} />
      <div className={clsx(styles.bottom, expand && styles.expand)}>
        <p className={styles.title}>{title}</p>
        <Spacer value={14} />
        <Paragraph maxWidth={375} color={'light'} size={'small'}>
          {text}
        </Paragraph>
        <Spacer value={30} />
        {/*{*/}
        {/*  expand ?*/}
        {/*    <LightButton onClick={onToggle}>Show less</LightButton> :*/}
        {/*    <SmallButton onClick={onToggle}>Show more</SmallButton>*/}
        {/*}*/}
        {/*<Desktop>*/}
        {/*  <section />*/}
        {/*</Desktop>*/}
      </div>
    </div>
  );
};

const createStyles = (theme: Theme, image: string) => ({
  root: css`
    border-radius: 12px;
    background: #1A2024;
      max-width: 495px;
  `,
  image: css`
    background-image: url(${image});
    background-repeat: no-repeat;
    background-size: cover;
    height: 240px;
    border-radius: 12px;
  `,
  bottom: css`
    position: relative;
    background: #1A2024;
    padding: 24px 16px;
    border-radius: 12px;
  `,
  expand: css`
    section {
      position: absolute;
      top: 93%;
      left: 0;
      background: #1A2024;
      height: 50px;
      width: 100%;
      border-radius: 12px;
    }
  `,
  title: css`
    color: #F9C106;
    font-weight: 800;
    font-size: 40px;
    line-height: 52px;
    ${theme.breakpoints.mobile.down} {
      font-size: 24px;
    }
  `
});

export default ForCard;
